import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const TEXT = {
  cooling: { PASS: 'Validated', NOT_APPLICABLE: 'Not applicable (non-tester)' },
  branchStock: { PASS: 'Available', NOT_APPLICABLE: 'Not applicable' },
  hoStock: { PASS: 'Available', SHARED: 'Available (same location as branch)', NOT_APPLICABLE: 'Not applicable' },
};
const say = (c, v) => TEXT[c][v] || v || '—';

export default function AcceptedNotice({ req, show }) {
  const accepted = (req.lines || []).filter(l => l.validationStatus === 'Accepted');
  if (!show || !accepted.length) return null;
  return (
    <div className="fm-card p-5 mb-6 border border-[#B9DCC3] bg-[#EEF7F0]" data-testid="req-accepted-notice">
      <div className="flex items-center gap-2 text-[15px] font-semibold text-[#2f6b41]"><CheckCircle2 size={18} /> Tester Order Accepted Successfully!</div>
      <div className="text-[13px] text-[#2f6b41] mt-1">Order Number: <span className="font-mono font-semibold" data-testid="req-accepted-order-no">{req.id}</span></div>
      <ul className="mt-3 grid gap-2 md:grid-cols-2">
        {accepted.map(a => {
          const ch = a.validationChecks || {};
          return (
            <li key={a.sku} className="rounded-md bg-white/70 border border-[#D4EAD9] px-3 py-2 text-[12.5px] text-[#1f4d2c]" data-testid={`req-accepted-line-${a.sku}`}>
              <div>Tester SKU: <span className="font-mono font-semibold">{a.sku}</span></div>
              <div>Requested Quantity: {a.qty} Units</div>
              <div>Cooling Period: {say('cooling', ch.cooling)} · Branch Stock: {say('branchStock', ch.branchStock)} · HO Stock: {say('hoStock', ch.hoStock)}</div>
            </li>
          );
        })}
      </ul>
      <p className="text-[12.5px] text-[#2f6b41] mt-3">Your Tester Item order has passed all three mandatory validations and has been accepted for further processing.</p>
    </div>
  );
}
